import React from "react";
import PropTypes from "prop-types";
import { Button, Popover } from "../../simple";

const defaultOptions = {
  className: "options-popover",
  popperClassName: "options-popper",
  hideArrow: true
};

export default function OptionTooltip(props) {
  const { tooltipOptions, actions } = props;
  return (
    <Popover {...tooltipOptions} {...defaultOptions}>
      {actions.map(action => (
        <Button
          key={action.label}
          className={`option-action ${
            action.className ? action.className : ""
          }`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            action.callback(e);
          }}
        >
          {action.label}
        </Button>
      ))}
    </Popover>
  );
}

OptionTooltip.propTypes = {
  tooltipOptions: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    target: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
    placement: PropTypes.string.isRequired
  }).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      className: PropTypes.string,
      callback: PropTypes.func.isRequired
    }).isRequired
  ).isRequired
};
